import { Component } from '@angular/core';
@Component({
    selector: 'yt-pseudo',
    templateUrl: './pseudo.component.html'
})
export class PseudoComponent{

}